import * as types from '../mutation-types';
import { getMenuList } from '@/api/base';
import { Message } from 'element-gui';
const state = {
  obj: [],
  stageObj: {
    stage: 0,
  },
  menuTrue: [],
  currentMenuTrue: {},
  isCoefficientOne: '',
  isCoefficientTwo: '',
};
const getters = {
  getMenu: (state) => state.obj,
  getStage: (state) => state.stageObj,
  getMenuTrue: (state) => state.menuTrue,
  getCurrentMenuTrue: (state) => state.currentMenuTrue,
  getCoefficientOne: (state) => state.isCoefficientOne,
  getCoefficientTwo: (state) => state.isCoefficientTwo,
};
const actions = {
  // 无阶段导航
  async getMenuStatus({ commit,dispatch }, obj) {

    await getMenuList({
      bidSectionId: obj.bidSectionId,
    }).then((res) => {
      if (res.code == 200) {
        if (res.data.list.length) {
          // 投标人不需要开标准备
          // let newMenuParams = [
          //   {menuName: "抽取结果", url: "/index/extract", index: 6, type: "抽取结果", status: 0},
          //   {menuName: "计算结果", url: "/index/result", index: 7, type: "计算结果", status: 0},
          //   {menuName: "抽取中标候选人", url: "/index/extractBidder", index: 8, type: "抽取中标候选人", status: 0},
          // ]
          // //  res.data.list[0].menus.splice(4,0,...newMenuParams)
          // newMenuParams.unshift(4,0)
          // Array.prototype.splice.apply(res.data.list[0].menus, newMenuParams); 
          
          // let newMenuParams2 = [
          //   {menuName: "替补中标候选人", url: "/index/alternateBidder", index: 10, type: "替补中标候选人", status: 0},
          // ]
          // res.data.list[0].menus = res.data.list[0].menus.concat(newMenuParams2)
          if (window.sessionStorage.getItem('roleKey') == '2') {
            if (res.data.list[0].menus[0].type === '开标准备') {
              res.data.list[0].menus.shift();
            }
            if (
              ['山西','福建','新疆','浙江','全国'].includes(JSON.parse(window.sessionStorage.getItem('row'))[0].region)
            ) {
              res.data.list[0].menus.forEach(function (item, index) {
                if (item.type === '公布投标人名单') {
                  // res.data.list[0].menus.splice(index, 1);
                  sessionStorage.setItem('menuName', item.menuName);
                }
              });
            }
          }
          // 重构数据 单阶段
          if (res.data.list.length === 1) {
            // 判断是否有系数抽取
            if (
              res.data.list[0].menus.some((item) => item.type === '系数抽取')
            ) {
              commit(types.GET_COEFFIENTONE_STATUS, '1');
            }

            // console.log(res.data.list[0].menus, '+++++menus11111111111+++++')

            // let obj1 = {
            //   // icon: "signatureList",
            //   index: 7,
            //   isLeaf: true,
            //   menuName: '特征码一览表',
            //   path: "/index/signatureList",
            //   status: 0,
            //   type: "特征码一览表",
            //   url: "/index/signatureList",
            // };
            // let obj2 = {
            //   // icon: "finalists",
            //   index: 8,
            //   isLeaf: true,
            //   menuName: '入围名单', 
            //   path: "/index/finalists",
            //   status: 0,
            //   type: "入围名单",
            //   url: "/index/finalists",
            // }
            
            // res.data.list[0].menus.splice(-1, 0, obj1, obj2)
            // if (window.sessionStorage.getItem('roleKey') == '2') { 
            //   res.data.list[0].menus.forEach(function (item, index) {
            //     if (item.type === '特征码一览表') {
            //       console.log('11111')
            //       res.data.list[0].menus.splice(index, 1);
            //     }
            //   });
            // } 

            // let obj1 = {
            //   index: 12,
            //   isLeaf: true,
            //   menuName: '评审结果',
            //   path: "/index/evalResult",
            //   status: 0,
            //   type: "评审结果",
            //   url: "/index/evalResult",
            // };
            // res.data.list[0].menus.push(obj1)
            
            // console.log(res.data.list[0].menus,'+++++menus+++++')


            // let obj1 = {
            //   icon: "signatureList",
            //   index: 7,
            //   isLeaf: true,
            //   menuName: '投标单位入围',
            //   path: "/index/openbidderEnter",
            //   status: 0,
            //   type: "投标单位入围",
            //   url: "/index/openbidderEnter",
            // };
            // let obj2 = {
            //   icon: "signatureList",
            //   index: 8,
            //   isLeaf: true,
            //   menuName: '随机赋码', 
            //   path: "/index/bidderRandomCode",
            //   status: 0,
            //   type: "随机赋码",
            //   url: "/index/bidderRandomCode",
            // } 
            // res.data.list[0].menus.splice(4, 0, obj1, obj2)

            // 投标人 隐藏 投标单位入围环节 
            
            console.log(JSON.parse(window.sessionStorage.getItem('obj')),'userTypeuserTypeuserType')
             if (JSON.parse(window.sessionStorage.getItem('obj')).userType == '2' ) { 
              // 投标人侧
              res.data.list[0].menus.forEach(function (item, index) {
                if (item.type === '随机抽球法-投标单位入围') {
                  res.data.list[0].menus.splice(index, 1);
                }
              });

              res.data.list[0].menus.forEach((item,index)=>{
                item.index = index+2
              })

            }

            console.log(res.data.list[0].menus,'33333333')
            res.data.list[0].menus.forEach(function (item) {
              item.path = item.url; //复制url
              item.stage = res.data.list[0].stage;
              switch (item.type) {
                case '开标准备':
                  item.isLeaf = true;
                  item.icon = 'raw';
                  break;
                case '公布投标人名单':
                  item.isLeaf = true;
                  item.icon = 'pre';
                  break;
                case '投标文件解密':
                  item.isLeaf = true;
                  item.icon = 'file';
                  break;
                case '唱标':
                  item.isLeaf = true;
                  item.icon = 'read';
                  break;
                case '随机抽球法-投标单位入围':
                  item.isLeaf = true;
                  item.icon = 'openbidderEnter';
                  break;
                case '随机抽球法-随机赋码':
                  item.isLeaf = true;
                  item.icon = 'bidderRandomCode';
                  break;
                case '系数抽取':
                  item.isLeaf = true;
                  item.icon = 'read';
                  break;
                case '特征码一览表':
                  item.isLeaf = true;
                  item.icon = 'signatureList';
                  break;
                case '入围名单':
                  item.isLeaf = true;
                  item.icon = 'finalists';
                  break;
                case '抽取参数':
                  item.isLeaf = true;
                  item.icon = 'extract';
                  break;
                case '计算结果':
                  item.isLeaf = true;
                  item.icon = 'result';
                  break;
                case '抽取中标候选人':
                  item.isLeaf = true;
                  item.icon = 'extractBidder';
                  break;
                case '开标结束':
                  item.isLeaf = true;
                  item.icon = 'finish';
                  break;
                case '替补中标候选人':
                  item.isLeaf = true;
                  item.icon = 'alternate';
                  break;
                case '评审结果':
                  item.isLeaf = true;
                  item.icon = 'evalResult';
                  break;
              }
            });
            commit(
              types.GET_MENU_STATUS,
              Array.isArray(res.data.list[0].menus)
                ? res.data.list[0].menus
                : []
            );
          } else {
            // 判断是否有系数抽取
            if (
              res.data.list[0].menus.some((item) => item.type === '系数抽取')
            ) {
              commit(types.GET_COEFFIENTONE_STATUS, '1');
            }
            if (
              res.data.list[1].menus.some((item) => item.type === '系数抽取')
            ) {
              commit(types.GET_COEFFIENTTWO_STATUS, '1');
            }
            res.data.list[0].menus.forEach(function (item) {
              item.path = item.url; //复制url
              item.stage = res.data.list[0].stage;
              switch (item.type) {
                case '开标准备':
                  item.isLeaf = true;
                  item.icon = 'raw';
                  break;
                case '公布投标人名单':
                  item.isLeaf = true;
                  item.icon = 'pre';
                  break;
                case '投标文件解密':
                  item.isLeaf = true;
                  item.icon = 'file';
                  break;
                case '唱标':
                  item.isLeaf = true;
                  item.icon = 'read';
                  break;
                case '系数抽取':
                  item.isLeaf = true;
                  item.icon = 'read';
                  break;
                case '特征码一览表':
                  item.isLeaf = true;
                  item.icon = 'signatureList';
                  break;
                case '入围名单':
                  item.isLeaf = true;
                  item.icon = 'finalists';
                  break;
                case '开标结束':
                  item.isLeaf = true;
                  item.icon = 'finish';
                  break;
              }
            });
            res.data.list[1].menus.forEach(function (item) {
              item.path = item.url; //复制url
              item.stage = res.data.list[1].stage;
              switch (item.type) {
                case '公布第一信封评审结果':
                  item.isLeaf = true;
                  item.icon = 'pre';
                  break;
                case '系数抽取':
                  item.isLeaf = true;
                  item.icon = 'read';
                  break;
                case '二信封唱标':
                  item.isLeaf = true;
                  item.icon = 'read';
                  break;
                case '评标基准价':
                  item.isLeaf = true;
                  item.icon = 'read';
                  break;
                case '二信封开标结束':
                  item.isLeaf = true;
                  item.icon = 'finish';
                  break;
              }
            });
            let result = [];
            for (let data of res.data.list[0].menus.concat(
              res.data.list[1].menus
            )) {
              result.push(data);
            }
            commit(types.GET_MENU_STATUS, Array.isArray(result) ? result : []);
          }
        }
      } else {
        Message.error({
          message: res.data.msg,
          iconClass: 'el-icon-circle-cross1',
        });
      }
    });
  },
  async setStage({ commit }, obj) {
    commit(types.GET_STAGE_STATUS, obj);
  },
  async setMenuTrue({ commit }, obj) {
    commit(types.GET_MENU_TRUE_STATUS, obj);
  },
  async setCurrentMenuTrue({ commit }, obj) {
    commit(types.GET_MENU_CURRENT_STATUS, obj);
  },
};
const mutations = {
  [types.GET_MENU_STATUS](state, obj) {
    state.obj = obj;
    window.sessionStorage.setItem('allMenu', JSON.stringify(obj));
  },
  [types.GET_STAGE_STATUS](state, obj) {
    state.stageObj = obj;
  },
  [types.GET_MENU_TRUE_STATUS](state, obj) {
    state.menuTrue = obj;
  },
  [types.GET_MENU_CURRENT_STATUS](state, obj) {
    state.currentMenuTrue = obj;
  },
  [types.GET_MENU_CURRENT_STATUS](state, obj) {
    state.currentMenuTrue = obj;
  },
  [types.GET_COEFFIENTONE_STATUS](state, obj) {
    state.isCoefficientOne = obj;
  },
  [types.GET_COEFFIENTTWO_STATUS](state, obj) {
    state.isCoefficientTwo = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
